import {
  Box,
  CircularProgress,
  Divider,
  IconButton,
  Paper,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import { ArrowDownUp } from 'lucide-react'
import { useContext, useEffect, useState } from 'react'
import { GlobalContext } from '../../App'
import { buscaPrograma, setProgramaAberto } from '../api'
import { isArray } from 'lodash'

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    minHeight: 60,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  subtitle: {
    flex: '1',
  },
}))

const Programa = ({
  children,
  codigo,
  ferramentas,
  onClickFerramentas,
  habTrocaLocal = false,
  habTitle = true,
}) => {
  const classes = useStyles()

  const { localAtendimento, dispatch } = useContext(GlobalContext)
  const [loading, setLoading] = useState(true)

  const [dadosPrograma, setDadosPrograma] = useState({
    codigo: '',
    titulo: '',
    subtitulo: '',
    tempo: 0,
    ip: '',
  })

  useEffect(() => {
    setProgramaAberto(codigo)

    buscaPrograma(codigo).then((res) => {
      setDadosPrograma(res.dados || {})
      dispatch({ type: 'ip', value: res?.dados?.ip })
      setLoading(false)
    })

    return () => {
      setProgramaAberto('')
    }
  }, [codigo, dispatch])

  if (loading)
    return (
      <Box style={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    )
  return (
    <>
      <Paper
        style={{
          borderRadius: 15,
          borderColor: 'white',
          padding: habTitle ? 10 : 0,
        }}
        variant="outlined"
      >
        {habTitle && (
          <>
            <Toolbar className={classes.toolbar}>
              <Typography gutterBottom>
                {dadosPrograma.titulo} -{' '}
                <small>{dadosPrograma.subtitulo}</small>
              </Typography>
              <Typography className={classes.subtitle}></Typography>

              {isArray(ferramentas) ? (
                <>
                  {ferramentas?.map(([icone, nome, chave], idx) => (
                    <Tooltip title={nome} key={idx}>
                      <IconButton onClick={() => onClickFerramentas(chave)}>
                        {icone}
                      </IconButton>
                    </Tooltip>
                  ))}
                </>
              ) : (
                ferramentas
              )}
              {habTrocaLocal && (
                <Tooltip
                  title={
                    localAtendimento
                      ? localAtendimento[1]
                      : 'Selecionar um Local de Atendimento'
                  }
                >
                  <IconButton
                    onClick={() => {
                      dispatch({ type: 'setAgenda', value: null })
                      dispatch({ type: 'setLocalAtendimento', value: null })
                    }}
                  >
                    <ArrowDownUp />
                  </IconButton>
                </Tooltip>
              )}
            </Toolbar>
            <Divider />
          </>
        )}

        <Box padding={2} style={{ padding: habTitle ? 10 : 0 }}>
          {children}
        </Box>
      </Paper>
    </>
  )
}

export default Programa
